import Modal from "Common/Components/Modal";
import React, { useState, useEffect } from "react";
import { Plus, Loader2 } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import { useAppServices } from "hook/services";
import { useParams } from "react-router-dom";
import { useUserInfo } from "context/user";

interface propTypes {
  handleRefresh: () => void;
}

const DeviceCreateModal = ({ handleRefresh }: propTypes) => {
  const AppService = useAppServices();
  const { user } = useUserInfo();
  const { locationId } = useParams();

  const [show, setShow] = useState<boolean>(false);
  const [qrCodeUrl, setQrCodeUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const toggle = () => setShow((prev) => !prev);

  const getQrCodeUrl = async () => {
    setLoading(true);
    const { response } = await AppService.webhook.phone_bridge.get_qr_code({
      query: `locationId=${locationId}&companyId=${user?.companyId}`,
    });

    if (response) {
      setQrCodeUrl(response.url);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (show) getQrCodeUrl();
  }, [show]);

  return (
    <>
      {/* Trigger Button */}
      <button
        type="button"
        onClick={toggle}
        className="flex items-center gap-2 rounded-md bg-custom-500 text-white px-4 py-2 text-sm font-medium hover:bg-custom-600 focus:outline-none focus:ring-2 focus:ring-custom-300 transition-all"
      >
        <Plus className="size-4" />
        Add Device
      </button>

      {/* Modal */}
      <Modal
        show={show}
        onHide={toggle}
        id="deviceModal"
        modal-center="true"
        className="fixed inset-0 z-[1055] flex items-center justify-center px-4"
        dialogClassName="w-full sm:w-[90%] md:w-[28rem] bg-white dark:bg-zink-700 rounded-xl shadow-lg transition-all"
      >
        {/* Header */}
        <Modal.Header className="flex items-center justify-between border-b p-4 dark:border-zink-500">
          <Modal.Title className="text-lg font-semibold text-gray-800 dark:text-gray-100">
            Register Device
          </Modal.Title>
        </Modal.Header>

        {/* Body */}
        <Modal.Body className="p-6 flex flex-col items-center justify-center text-center space-y-4">
          {loading ? (
            <div className="flex flex-col items-center justify-center py-8">
              <Loader2 className="size-6 animate-spin text-custom-500 mb-3" />
              <p className="text-sm text-gray-500 dark:text-gray-300">
                Generating QR Code...
              </p>
            </div>
          ) : qrCodeUrl ? (
            <div className="flex flex-col items-center">
              <QRCodeCanvas
                value={qrCodeUrl}
                size={220}
                level="H"
                includeMargin={true}
              />
              <p className="mt-4 text-sm text-gray-600 dark:text-gray-300">
                Scan this QR code to register your device.
              </p>
            </div>
          ) : (
            <p className="text-gray-500 dark:text-gray-300">
              Unable to load QR code. Please try again.
            </p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeviceCreateModal;
